import React, { useState, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import "./Auth.css";

import pic from "../../Assets/login.jpg";
import Login from "./Components/auth/Login";
import Signup from "./Components/auth/Signup";
import ForgotPassword from "./Components/auth/ForgotPassword";
import ResetPasswordAuth from "./Components/auth/ResetPasswordAuth";
import { MyContext } from "../../Context/MyContext";
import { resolveLoginRedirect } from "../../utils/resolveLoginRedirect";
import {
  clearInvalidUserSession,
  isUserSessionActive,
  isValidAuthToken,
} from "../../utils/authSession";

const Auth = () => {
  const { user } = useContext(MyContext);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("login");

  useEffect(() => {
    clearInvalidUserSession();
  }, []);

  const sessionActive =
    isUserSessionActive() ||
    isValidAuthToken(user?.access_token);

  if (sessionActive) {
    return <Navigate to={resolveLoginRedirect(location, "/")} replace />;
  }

  const renderComponent = () => {
    if (activeTab === "login") return <Login setActiveTab={setActiveTab} />;
    if (activeTab === "signup") return <Signup setActiveTab={setActiveTab} />;
    if (activeTab === "forgot_password")
      return <ForgotPassword setActiveTab={setActiveTab} />;
    if (activeTab === "reset_password")
      return <ResetPasswordAuth setActiveTab={setActiveTab} />;
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-image-section">
          <img src={pic} alt="property" />
          <div className="auth-image-overlay">
            <span className="brand-name">Properties Infinite</span>
            <h1>Turning Your Property Dreams<br />Into Reality</h1>
            <p>Plots, Villas, Apartments, And Rental Properties With Trusted Listings And Verified Sellers & Documentation</p>
          </div>
        </div>

        <div className="auth-form-section">
          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default Auth;
